export default "__VITE_ASSET__oT4Wcgrc__"